import apiClient from "api/client/axios.client";
import { CategoryDto } from "types/notice/CategoryDto";

 
export const getCategories = async (): Promise<CategoryDto[]> => {
  // در OData دیتا معمولاً داخل پراپرتی value قرار دارد
  const response = await apiClient.get<{ value: CategoryDto[] }>('/Notice/odata/CategoriesOData');
  return response.data.value;
};
